  <template>
    <div>
      <DefaultNotification
      v-if="isOpen"
      @update-card="updateCard"
      @openCard="$emit('openCard', $event)"
      @close-notification="closeNotification"
      @toggle-order="toggleOrder"
        :title="notification.title"
        :expand-text="notification.expandText"
        :notificationSwitch="false"
        :cards="cards"
        :viewedCards="viewedCards"
      />
    </div>
  </template>

<script>
import DefaultNotification from './NotificacaoPadrao.vue'
import NotificationsCardRepository from '@/shared/http/repositories/crm/notificationscard.js'
import moment from 'moment'

export default {
  components: {
    DefaultNotification
  },
  mounted () {
    this.retrieveNotifications()
  },
  data () {
    return {
      notification:
        {
          title: 'Oportunidades',
          expandText: 'Visualizados'
        },
      cards: [],
      viewedCards: [],
      data: [],
      isOpen: true,
      asc: true
    }
  },
  methods: {
    closeNotification () {
      this.isOpen = false
    },
    formatDate (value) {
      if (value) {
        return moment(value).fromNow()
      }
      return null
    },
    retrieveNotifications () {
      this.getViewed()
      this.getNotViewed()
    },
    getViewed () {
      let dataFilter = []
      let order = this.asc ? 'asc' : 'desc'
      let params = `visualizado=true&sort=dataNotificiacao,${order}`
      NotificationsCardRepository.searchNotificationsUserCustom(params)
        .then(response => {
          if (response.data) {
            this.data = response.data.content
            this.data.forEach(element => {
              let card = {
                cardIcon: 'fas fa-lightbulb',
                cardIconText: this.formatDate(element.dataNotificiacao),
                cardPersonPic: '',
                cardTitle: element.card.nomePessoa,
                cardDescription: element.card.boardColumn.board.nome ? element.card.boardColumn.board.nome : element.card.boardColumn.nome,
                cardChecked: element.visualizado,
                cardObj: element
              }
              dataFilter.push(card)
              this.viewedCards = dataFilter
            })
          }
        })
        .catch(this.onException)
    },
    getNotViewed () {
      let dataFilter = []
      let order = this.asc ? 'asc' : 'desc'
      let params = `visualizado=false&sort=dataNotificiacao,${order}`
      NotificationsCardRepository.searchNotificationsUserCustom(params)
        .then(response => {
          if (response.data) {
            this.data = response.data.content
            this.data.forEach(element => {
              let card = {
                cardIcon: 'fas fa-lightbulb',
                cardIconText: this.formatDate(element.dataNotificiacao),
                cardPersonPic: '',
                cardTitle: element.card.nomePessoa,
                cardDescription: element.card.boardColumn.board.nome ? element.card.boardColumn.board.nome : element.card.boardColumn.nome,
                cardChecked: element.visualizado,
                cardObj: element
              }
              dataFilter.push(card)
              this.cards = dataFilter
            })
          }
        })
        .catch(this.onException)
    },
    updateCard (card) {
      this.retrieveNotifications()
    },
    toggleOrder () {
      this.asc = !this.asc
      this.retrieveNotifications()
    }
  },
  emits: ['update-card', 'close-notification', 'toogle-order']
}
</script>



// WEBPACK FOOTER //
// src/components/UI/notificacao/Oportunidades.vue